// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1wOjp","content":"ManualTimeModal_content__15nW4"};